import { Role } from './roles';

export type ConfigureNavIconConfig = {
  type: 'iconoir';
  name: 'CreateAgent' | 'Layers3' | 'CubeBandage' | 'LightBulbOn' | 'DatabaseStar' | 'Tools' | 'Presentation' | 'BookOpen' | 'Building';
};

export type ConfigureNavItem = {
  id: string;
  labelKey: string;
  path: string;
  icon: ConfigureNavIconConfig;
  /** If set, the item is shown only when the user has at least one of these roles. */
  roles?: Role[];
};

export const CONFIGURE_NAV_ITEMS: ConfigureNavItem[] = [
  {
    id: 'skills',
    labelKey: 'SKILLS',
    path: '/skills',
    icon: { type: 'iconoir', name: 'Layers3' },
  },
  {
    id: 'knowledge-base',
    labelKey: 'KNOWLEDGE_BASE',
    path: '/knowledge-base',
    icon: { type: 'iconoir', name: 'DatabaseStar' },
  },
  {
    id: 'prompts',
    labelKey: 'PROMPTS',
    path: '/prompts',
    icon: { type: 'iconoir', name: 'BookOpen' },
  },
];

export const getVisibleConfigureNavItems = (userRoles: string[] = []) =>
  CONFIGURE_NAV_ITEMS.filter(
    (item) => !item.roles?.length || item.roles.some((role) => userRoles.includes(role))
  );

const CONFIGURE_ROUTE_PREFIXES = [
  '/configure',
  '/skills',
  '/knowledge-base',
  '/prompts',
];

export const isConfigureRoute = (pathname: string) =>
  CONFIGURE_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

/** Open the overlay sheet only when first entering Advanced, not when switching Advanced routes. */
export const shouldOpenConfigureOverlayOnPathChange = (
  previousPathname: string,
  nextPathname: string
) => isConfigureRoute(nextPathname) && !isConfigureRoute(previousPathname);

export const SIDEBAR_CONFIGURE_PANEL_WIDTH = '17.5rem';
